import { ERR_RAS_MIN, ERR_RAS_MAX } from '../../../core/js/enums/localizationEnums';

/**
 * Concat a bunch of values into a comma separated string for the email
 * @param {String} styleNumber the product's style number
 * @param {String} materialName the product's material name
 * @param {Object} swatch a swatch object
 * @returns {String} comma separated swatch values
 */
export const buildSwatchString = (styleNumber, materialName, swatch) => {
    // We no longer use displayName so that the RAS parser works for
    // both MTO RAS requests, and non MTO RAS requests
    // Ideally, we would use material name but there doesn't
    // appear to be a way to infer it from the product data
    // See UW-24959
    // NOTE: If you are updating the separators here, also update them in
    // getSelectedSwatchString() in src/sdk/urbnweb/features/mto/js/reducers/rasReducer.js
    return `${styleNumber};${swatch.colorCode};${materialName};${swatch.displayName}`;
};

export function getRASMinimumMessage() {
    return {
        slug: ERR_RAS_MIN
    };
}

export function getRASMaximumMessage() {
    return {
        slug: ERR_RAS_MAX
    };
}
